/**
 * Additional polyfills for browser compatibility
 * Most polyfills are now handled by vite-plugin-node-polyfills
 */

// This file provides polyfills needed for Colyseus.js to work properly in the browser

// Ensure global is defined
if (typeof global === 'undefined') {
  ;(window as any).global = window
}

// Ensure process is available
if (typeof process === 'undefined') {
  ;(window as any).process = { env: {} }
}

// Prevent errors related to http.globalAgent
if (typeof window !== 'undefined') {
  const httpModule = (window as any).http
  if (httpModule && !httpModule.globalAgent) {
    httpModule.globalAgent = {}
  }
}

export default {}
